import { ProductGroupEntity } from '../entities';
import { BusinessUnitRepository } from '../ports/repositories';

export class FindProductGroupUseCase {
  constructor(private readonly repo: BusinessUnitRepository) {}

  async run(): Promise<ProductGroupEntity[]> {
    return this.repo.findProductGroups();
  }
}
